import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from 'seagull';
import { QuestionCircle } from 'seagull/icons/essentials';
import styles from './HintIcon.module.scss';
export const HintIcon = (param)=>{
    let { info, size = 20, testId } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: info,
        placement: "top",
        children: /*#__PURE__*/ _jsx("span", {
            className: styles.root,
            "data-testid": testId,
            tabIndex: 0,
            children: /*#__PURE__*/ _jsx(QuestionCircle, {
                size: size
            })
        })
    });
};
